import React from 'react';
import { Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';
import PrivateRoute from './views/PrivateRoute';
import Login from './views/login';
import Dealer from './views/dealership';
import Journey from './views/journey';
import Dashboard from './views/MainLayout';
import DevPanelLayout from './views/devpanel/DevPanelLayout';

const Routes = () => {
  const isDevPanelOpen = useSelector((state) => state.showDevPanel?.isDevPanelOpen);
  return (
    <Switch>
      <Route exact path="/" component={Login} />
      <PrivateRoute exact path="/dashboard" component={!isDevPanelOpen ? Dashboard : DevPanelLayout} />
      <PrivateRoute exact path="/dealership" component={Dealer} />
      <PrivateRoute exact path="/journey" component={Journey} />
    </Switch>
  );
};

export default Routes;
